import { createIntl, createIntlCache } from 'react-intl'

const cache = createIntlCache()

export const GlobalIntl = createIntl(
    {
        /**
         * locale should be changed on application initialization.
         */
        locale: 'en',
        defaultLocale: 'en',
        messages: {},
    },
    cache,
)
